import { Component, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { NgFor, CommonModule } from '@angular/common';
import { debounceTime } from 'rxjs';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { MatRadioButton } from '@angular/material/radio';
import { MatRadioGroup } from '@angular/material/radio';



@Component({
  selector: 'app-process-filter',
  templateUrl: './process-filter-dialog.component.html',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    NgFor,
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatRadioButton,
    MatRadioGroup
  ],
})
export class ProcessFilterDialogComponent {
  @Output() filterChange = new EventEmitter<any>();

  filterForm: FormGroup;

  constructor() {
    // Inicializando o FormGroup com os controles
    this.filterForm = new FormGroup({
      numeroProcesso: new FormControl(''),
      empresa: new FormControl(''),
      modalidade: new FormControl(''),
      fase: new FormControl(''),
      cpfCnpj: new FormControl(''),
      situacaoRequerimento: new FormControl(''),
    });

    // Observando mudanças no formulário como um todo, com debounceTime
    this.filterForm.valueChanges
      .pipe(debounceTime(300))
      .subscribe(() => this.applyFilters());
  }

  // Método para aplicar os filtros
  applyFilters(): void {
    const filterValues = this.filterForm.value;

    // Emitindo o objeto de filtros ao invés de uma string
    this.filterChange.emit(filterValues);
  }

  // Método para limpar todos os filtros
  clearFilters(): void {
    this.filterForm.reset();
    this.applyFilters(); // Emite os filtros após a limpeza
  }
}